<template>
  <transition name="fade-slide">
    <div class="ai-processing" v-if="aiProcessing">
      <div class="icon-wrapper">
        <fp-icon symbol="ai-sparkles" size="30"></fp-icon>
      </div>
      <p>מעבד עם OLYO AI</p>
      <span>נא המתן...</span>
    </div>
  </transition>
</template>
<script setup>
import FpIcon from "@/components/FpIcon.vue";
import {computed} from "vue";
import store from "@/store";

const aiProcessing = computed(() => {
  return store.getters['aIAgent/aiProcessing'];
})
</script>
<style lang="scss" scoped>
.ai-processing {
  text-align: center;
  background-color: #0f1d2c;
  position: fixed;
  z-index: 10003;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 30px;
  display: flex;
  flex-flow: column;
  gap: 10px;

  .icon-wrapper {
    background-color: #0e3043;
    border-radius: 100%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline: auto;
    margin-bottom: 10px;

    svg, svg path {
      fill: #0e3043;
      stroke: #07859d;
    }
  }
  p {
    color: #fff;
  }
  span {
    color: #07859d;
  }
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease-out;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translate(-50%, -10%);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translate(-50%, -90%);
}
</style>